module.exports = __webpack_public_path__ + "static/media/live_2.d4ce96ae.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/video/live_2.mp4
// module id = 177
// module chunks = 0